import styled from 'styled-components';

import { getThemeColor, media } from '@utils/styled';

import Typography from '@common/components/Typography';

export const RelatedProductsContainer = styled.div`
  ${media.from880down`
    background: linear-gradient(180deg, ${getThemeColor('bluegrey.97')} 0%, rgba(0,0,0,0) 100%);

    ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 1)}
    ${({ theme }) => theme.getFluidSpacing('margin-left', 'widthBased', 0, true)};
    ${({ theme }) => theme.getFluidSpacing('margin-right', 'widthBased', 0, true)};

    ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 1)}
    ${({ theme }) => theme.getFluidSpacing('padding-left', 'widthBased', 0)};
    ${({ theme }) => theme.getFluidSpacing('padding-right', 'widthBased', 0)};
  `}
`;

export const RelatedProductsTitle = styled(Typography).attrs({
  variant: 'h4',
  customAs: 'h2',
})`
  margin: 0;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 1)}
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 4)}
  color: ${getThemeColor('bluegrey.70')};
  text-align: center;
`;
